if (typeof window !== 'undefined' && window.fetch) {
  window.fetch = window.fetch.bind(window);
}
